import React from 'react';
import { FormattedMessage } from 'react-intl';
import { TranslationKeys } from '../../../../../translations';
import type { ConnectionInspectorResult } from '../../../../../hooks/api/admin';
import format from '../../../../../utils/formatter';
import { COLOR_CONNECTION, COLOR_EMPLOYER, COLOR_OWNER, COLOR_STATS } from '../constants';
import { FieldRow } from './FieldRow';
import { StatusChip } from './StatusChip';

export const ConnectionFields = ({ data }: { data: ConnectionInspectorResult }) => (
  <>
    <FieldRow
      color={COLOR_CONNECTION}
      labelId={TranslationKeys.tools_connectionInspector_connectionName}
      value={data.connectionName}
      navigateTo={`/employers/${data.employerId}/connections/${data.connectionId}/info`}
    />
    <FieldRow
      color={COLOR_CONNECTION}
      labelId={TranslationKeys.tools_connectionInspector_productName}
      value={data.productName}
    />
    <FieldRow
      color={COLOR_CONNECTION}
      labelId={TranslationKeys.tools_connectionInspector_salaryPackage}
      value={<FormattedMessage id={`packages.type.${data.salaryPackage}`} />}
    />
    <FieldRow
      color={COLOR_CONNECTION}
      labelId={TranslationKeys.tools_connectionInspector_createdAt}
      value={format.date(data.createdAt)}
    />
    <FieldRow
      color={COLOR_CONNECTION}
      labelId={TranslationKeys.tools_connectionInspector_latestRun}
      value={data.latestRun ? format.date(data.latestRun) : '—'}
    />
    <FieldRow
      color={COLOR_CONNECTION}
      labelId={TranslationKeys.tools_connectionInspector_deleted}
      value={
        <StatusChip
          value={data.deleted}
          trueLabelId={TranslationKeys.tools_connectionInspector_statusDeleted}
          falseLabelId={TranslationKeys.tools_connectionInspector_statusActive}
          invertColors
        />
      }
    />
  </>
);

export const EmployerFields = ({ data }: { data: ConnectionInspectorResult }) => (
  <>
    <FieldRow
      color={COLOR_EMPLOYER}
      labelId={TranslationKeys.tools_connectionInspector_employerName}
      value={data.employerName}
      navigateTo={`/employers/${data.employerId}/info`}
    />
    <FieldRow
      color={COLOR_EMPLOYER}
      labelId={TranslationKeys.tools_connectionInspector_employerIsPensioenbijIntegration}
      value={
        <StatusChip
          value={data.employerIsPensioenbijIntegration}
          trueLabelId={TranslationKeys.tools_connectionInspector_yes}
          falseLabelId={TranslationKeys.tools_connectionInspector_no}
        />
      }
    />
  </>
);

export const OwnerFields = ({ data }: { data: ConnectionInspectorResult }) => (
  <FieldRow
    color={COLOR_OWNER}
    labelId={TranslationKeys.tools_connectionInspector_ownerName}
    value={data.ownerName}
    navigateTo={`/owners/${data.ownerId}/info`}
  />
);

export const StatsFields = ({ data }: { data: ConnectionInspectorResult }) => (
  <>
    <FieldRow
      color={COLOR_STATS}
      labelId={TranslationKeys.tools_connectionInspector_numberOfEmployees}
      value={data.numberOfEmployees}
    />
    <FieldRow
      color={COLOR_STATS}
      labelId={TranslationKeys.tools_connectionInspector_numberOfEvents}
      value={data.numberOfEvents}
    />
  </>
);
